<template>
	<div class="homepage">
		<main>
			<b-container>
				<div class="logo-container">
					<img src="/img/logo_claim.svg" alt="skilldoo"/>
				</div>
				<div class="left">
					<div class="bubbles">
						<a class="link-bubble customer" :href="urlCustomer">
							<span>Du suchst</span>
							<span>Verstärkung<br/>für Euer Team</span>
							<Button
								:href="urlCustomer"
								icon="caret-right"
								text="Passende Mitarbeiter finden"
								class="link-bubble-button d-none d-md-inline-block"
							/>
							<Button
								:href="urlCustomer"
								icon="caret-right"
								text="Mitarbeiter finden"
								class="link-bubble-button d-md-none"
							/>
						</a>
						<a class="link-bubble application" :href="urlApplicant">
							<span>Du suchst</span>
							<span>eine Tätigkeit<br/>für dich persönlich</span>
							<Button
								:href="urlApplicant"
								icon="caret-right"
								text="Passenden Job finden"
								class="link-bubble-button d-none d-md-inline-block"
							/>
							<Button
								:href="urlApplicant"
								icon="caret-right"
								text="Job finden"
								class="link-bubble-button d-md-none"
							/>
						</a>
					</div>
					<div class="avatar">
						<Avatar :avatar="avatarCatNotebook"/>
					</div>
				</div>
			</b-container>
		</main>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import Button from "@/vue/common/Button";
import Avatar, {CAT_NOTEBOOK} from "@/vue/common/image/Avatar.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";

const FEATURES = [
	'<span>ANONYM</span> - Du entscheidest wann deine Daten sichtbar werden',
	'Einzigartiges <span>skilldoo Matching</span>',
	'<span>KOSTENLOS</span> für Bewerber',
	'<span>Keine Vorauszahlung</span> für Unternehmen',
];

export default {

	components: {
		Avatar,
		Button,
		Icon,
	},

	mounted ()
	{
		Event.push(
			new EventData()
				.setEvent(Event.PAGE_VISIT)
				.setAction('Homeseite')
		);
	},

	computed: {
		urlApplicant ()
		{
			return '/jobfinden';
		},
		urlCustomer ()
		{
			return '/mitarbeiterfinden';
		},
		features ()
		{
			return FEATURES;
		},
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		}
	}
}
</script>
